import { createSlice } from "@reduxjs/toolkit";
import { getPlans } from "./thunk";

export interface IState {
  plans: any;
  isPlanLoading: boolean;
  isPlanSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  plans: null,
  isPlanLoading: false,
  isPlanSuccess: false,

  error: {},
};

const PlanSlice = createSlice({
  name: "Plan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getPlans
    builder.addCase(getPlans.pending, (state: IState, action: any) => {
      state.isPlanLoading = true;
    });
    builder.addCase(getPlans.fulfilled, (state: IState, action: any) => {
      state.plans = action.payload.data;
      state.isPlanSuccess = true;
      state.isPlanLoading = false;
    });
    builder.addCase(getPlans.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPlanSuccess = false;
      state.isPlanLoading = false;
    });
  },
});

export default PlanSlice.reducer;